import CustomAvatar from '@/@core/components/mui/Avatar'
import { ICompany } from '@/@data'
import { getInitials } from '@/utils/getInitials'
import { SxProps, Theme, Tooltip, Typography } from '@mui/material'
import Link from '../Link'

const getAvatar = (params: Pick<ICompany, 'logo_file' | 'name'>) => {
  const { logo_file, name } = params

  if (logo_file) {
    return <CustomAvatar src={logo_file.tiny_url} skin='light' size={34} />
  } else {
    return (
      <CustomAvatar skin='light' size={34}>
        {getInitials(name as string)}
      </CustomAvatar>
    )
  }
}

export const CompanyLogo = ({ company, link, sx }: { company: ICompany; link?: string; sx?: SxProps<Theme> }) => {
  return (
    <Link href={link || `/cms/employer/${company?.id}`} className='flex items-center gap-4'>
      {getAvatar({ logo_file: company?.logo_file, name: company?.name || '-' })}
      <div className='flex flex-col'>
        <Tooltip title={company?.name || '-'} placement='top' arrow>
          <Typography
            className='font-medium max-w-[200px] whitespace-nowrap overflow-hidden text-ellipsis text-bold'
            color='text.primary'
            sx={sx}
          >
            {company?.name || '-'}
          </Typography>
        </Tooltip>

        <Typography variant='body2'>{company?.system_code || '-'}</Typography>
      </div>
    </Link>
  )
}
